import { useKeycloak } from '@react-keycloak/web';
import React, { FC, useEffect, useState } from 'react';
import { useAppDispatch } from '../../state/hooks';
// import { companySelector, getCompany } from '../../state/slices';
import { useSelector } from 'react-redux';
import { Button, Card, CardActions, CardContent, CardHeader, Grid, Input, Modal, TextField } from '@mui/material';
import { formatDateForDisplay } from '../../state/DateUtils';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { issueVc, issueVcSelector } from '../../state/slices/issuevc';

export const ScanQRCode: FC = () => {
    const dispatch = useAppDispatch();
    const { keycloak, initialized } = useKeycloak();
    const [searchParams] = useSearchParams();
    const configurationId = searchParams.get('id');
    let navigate = useNavigate();
    const issueState = useSelector(issueVcSelector);

    useEffect(() => {
        if (configurationId) {
           dispatch(issueVc({jwtToken: keycloak.token!, templateId: configurationId, callbackUrl: ''}));
        }
    }, [keycloak.token, configurationId]);


    function annuleer() {
        navigate('/company');
    }

    return (
        <div>
            <Card variant="outlined">
                <CardHeader title='Issue Personal ID credential'/>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            Scan the QR-code below with your personal wallet to receive the PID credential in your wallet.
                        </Grid>
                        <Grid item xs={12}>
                            { issueState.singleItem ? <QRCodeCanvas
                                value={issueState.singleItem!.oidcUrl}
                                size={300}/> : <></>}
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='outlined' onClick={() => annuleer()}>Cancel</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </div>
    );
};
